<!-- Wrapper for cells inside vuetify datatable 
     Pass in custom classes in the component when necessary for styling purposes.

     E.g: 
     <data-table-cell class="info">
       <div> Your stuff goes here </div>   
     </data-table-cell>
-->
<template>
  <div class="table-cell-wrapper" v-bind="$attrs">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
@import "@styles/abstracts/functions";
@import "@styles/layout/z-map";
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.table-cell-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  padding: $spacing-03;
  height: 100%;

  &.header-action {
    padding: 0;
  }

  > span,
  time,
  .bx--link,
  .title,
  .status {
    z-index: z-map("default");
  }

  .bx--link {
    white-space: normal;
  }

  time {
    &.date {
      @include carbon--type-style("body-short-01", true);
      color: $text-01;
    }
    &.time {
      @include carbon--type-style("label-01", true);
    }
  }

  .sls-icon {
    z-index: z-map("default");
    flex: 0 0 auto;
  }

  &.active {
    position: static;
    background-color: tint($interactive-01, 90%);

    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background-color: tint($interactive-01, 90%);
      z-index: -1;
    }
  }
}
</style>
